import React, { FC } from 'react'
import AchFeesContainer from 'containers/AchFees'

const AchFeesPage: FC = () => <AchFeesContainer />

export default AchFeesPage
